import script from "./CloseDates.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseDates.vue?vue&type=script&setup=true&lang=js"

import "./CloseDates.vue?vue&type=style&index=0&id=4732aaaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4732aaaa"]])

export default __exports__